// extracted by mini-css-extract-plugin
export default {"svgParentContainer":"styles_svgParentContainer__icPO0","fullSize":"styles_fullSize__NIH3A"};